import React, { useEffect, useState } from 'react';
import { Avatar } from '@mui/material';
import { Person as PersonIcon } from '@mui/icons-material';
import {
  loadPatientProfilePicture,
  patientHasProfilePicture,
  patientProfilePictureRevision,
} from '../utils/patientProfilePicture';

const PatientProfileAvatar = ({
  persona,
  personaId,
  hasPicture,
  pictureRevision,
  size = 40,
  sx,
}) => {
  const id = personaId ?? persona?.id;
  const revision = pictureRevision != null
    ? Number(pictureRevision) || 0
    : patientProfilePictureRevision(persona);
  const showPicture = hasPicture != null ? Boolean(hasPicture) : patientHasProfilePicture(persona);
  const [src, setSrc] = useState(null);

  useEffect(() => {
    if (!showPicture || id == null || Number.isNaN(Number(id))) {
      setSrc(null);
      return undefined;
    }
    let cancelled = false;
    loadPatientProfilePicture(id, revision)
      .then((url) => {
        if (!cancelled) setSrc(url || null);
      })
      .catch(() => {
        if (!cancelled) setSrc(null);
      });
    return () => {
      cancelled = true;
    };
  }, [id, showPicture, revision]);

  return (
    <Avatar
      src={src || undefined}
      alt=""
      sx={{
        width: size,
        height: size,
        bgcolor: src ? 'grey.200' : 'primary.main',
        flexShrink: 0,
        ...sx,
      }}
    >
      {!src && <PersonIcon fontSize={size >= 56 ? 'large' : 'medium'} />}
    </Avatar>
  );
};

export default PatientProfileAvatar;
